import { Button } from '@kerfjs/ui/button';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { Toolbar } from '@kerfjs/ui/toolbar';
import type { SafeHtml } from 'kerfjs';
import { Plus } from 'lucide';

/** Secondary header action for the Currencies settings page. */
export function CurrenciesHeader(): SafeHtml {
  return (
    <Toolbar
      label="Currency Actions"
      trailing={
        <Button
          size="default"
          tone="brand"
          emphasis="primary"
          action="currency-picker-open"
          icon={<LucideIcon icon={Plus} name="" />}
        >
          Add Currency…
        </Button>
      }
    />
  );
}
